// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Ilml","range":"MonthRangeSwitch_range__3g_0j","disabled":"MonthRangeSwitch_disabled__3FIiT"};